function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { trackBigBrainEventOnServer } from "/server/services/bigbrain-tracking-service/bigbrain-tracking-service";
import { SOLUTION_PAGE_WITH_INVALID_SOLUTION_ERROR, SOLUTION_PAGE_ERROR } from "constants/bigbrain-event-types";
import Error from "next/error";
import { SINGLE_SOLUTION_PAGE_TYPE, SOLUTIONS_IN_CATEGORY_PAGE_TYPE, SOLUTIONS_HOME_PAGE_TYPE, SOLUTIONS_SEARCH_PAGE_TYPE } from "constants/template-center/solution-page-types";
import SolutionPageLayoutComponent from "components/pages/solutions/solution-page-layout-component";
import { solutionExists, categoryExists, filterCategories } from "template-store/services/solutions-service";
import BaseTemplatePage from "../../generated-templates/base-template-page";
class SolutionPage extends BaseTemplatePage {
    static getInitialProps({ req, res, asPath, query }) {
        var _this = this;
        return _async_to_generator(function*() {
            const superInitialProps = yield BaseTemplatePage.getInitialProps({
                req,
                res,
                asPath
            });
            const { solutionId, categoryId } = req.params;
            const { term } = req.query;
            const { pageType } = query;
            res.statusCode = 200;
            try {
                const { getMondaySolutionData } = require("/server/services/solutions/solutions-api-service");
                const { localeToUse } = superInitialProps;
                const solutionData = yield getMondaySolutionData(localeToUse);
                const allSolutions = solutionData.solutions;
                const allCategories = filterCategories(solutionData.categories, allSolutions);
                const tabsMetadata = {
                    integrations: solutionData.integrations,
                    columns: solutionData.columns,
                    views: solutionData.views
                };
                const isValid = _this.validate(allSolutions, allCategories, pageType, {
                    solutionId,
                    categoryId
                });
                if (!isValid) {
                    yield trackBigBrainEventOnServer(SOLUTION_PAGE_ERROR, {
                        placement: req.url,
                        info2: req.params,
                        directObject: req.hostname
                    });
                    res.statusCode = 404;
                }
                return _object_spread_props(_object_spread({}, superInitialProps), {
                    allSolutions,
                    allCategories,
                    pageType,
                    searchTermFromAdressBar: term,
                    solutionId,
                    categoryId,
                    tabsMetadata,
                    asPath,
                    statusCode: res.statusCode
                });
            } catch (e) {
                yield trackBigBrainEventOnServer(SOLUTION_PAGE_WITH_INVALID_SOLUTION_ERROR, {
                    placement: req.url,
                    info1: e.message,
                    info2: req.params,
                    directObject: req.hostname
                });
                console.log(e.message);
                res.statusCode = 500;
                return {
                    statusCode: res.statusCode
                };
            }
        })();
    }
    render() {
        const _this_props = this.props, { statusCode } = _this_props, restProps = _object_without_properties(_this_props, [
            "statusCode"
        ]);
        if (statusCode !== 200) return /*#__PURE__*/ _jsx(Error, {
            statusCode: statusCode
        });
        return /*#__PURE__*/ _jsx(SolutionPageLayoutComponent, _object_spread({}, restProps));
    }
}
_define_property(SolutionPage, "validate", (allSolutions, allCategories, pageType, { solutionId, categoryId })=>{
    switch(pageType){
        case SINGLE_SOLUTION_PAGE_TYPE:
            {
                return !!solutionId && solutionExists(allSolutions, solutionId);
            }
        case SOLUTIONS_IN_CATEGORY_PAGE_TYPE:
            {
                return !!categoryId && categoryExists(allCategories, categoryId);
            }
        case SOLUTIONS_SEARCH_PAGE_TYPE:
        case SOLUTIONS_HOME_PAGE_TYPE:
            {
                return true;
            }
        default:
            {
                return false; // must come with a page type
            }
    }
});
export { SolutionPage as default };
